<template>
  <div>
    <!--Header Components-->
    <base-header class="mt-4 pb-6" type="" />
    <b-container fluid class="mt--6">
      <div>
        <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
      </div>
      <b-row>
        <b-col lg="12">
          <div class="card-wrapper">
            <card>
              <div slot="header" class="mb-0">
                <b-row>
                  <b-col cols="8">
                    <h3>{{language_terms['BOM_ASSEMBLIES']}}</h3>
                  </b-col>
                  <b-col cols="4">
                    <base-button type="success" @click="onClickAdd" class="float-right">
                      <i class="fa fa-plus"></i>
                    </base-button>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                  <b-col lg="3" md="3">
                  <base-input :label="language_terms['QUICK_FILTER']" v-model="filter.keyword"
                    v-on:keyup.enter="onClickSearch">
                  </base-input>
                </b-col>
                <b-col lg="3" md="3">
                  <base-input :label="language_terms['DATE_FROM']">
                    <flat-picker slot-scope="{focus, blur}" @on-open="focus" @on-close="blur"
                      style="background-color: white;" class="form-control datepicker" v-model="filter.from_date">
                    </flat-picker>
                  </base-input>
                </b-col>
                <b-col lg="3" md="3">
                  <base-input :label="language_terms['DATE_TO']">
                    <flat-picker slot-scope="{focus, blur}" @on-open="focus" @on-close="blur"
                      style="background-color: white;" class="form-control datepicker" v-model="filter.to_date">
                    </flat-picker>
                  </base-input>
                </b-col>
                <b-col lg="2" md="2">
                  <base-input :label="language_terms['TYPE']">
                    <el-select filterable clearable v-model="filter.is_assembled" >
                        <el-option
                            v-for="item in assembly_options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </base-input>
                </b-col>
                <b-col lg="1" md="1" class="mt-4">
                  <base-button type="primary" @click="onClickSearch" class="mt-2">
                    <i class="fa fa-search"></i>
                  </base-button>
                </b-col>
              </b-row>
            </card>
              <card v-if="items.length > 0">
                <b-row>
                  <b-col cols="12">
                  <b-table-simple hover responsive>
                    <b-thead head-variant="light">
                      <b-th width="20px">{{language_terms['DOC_#']}}</b-th>
                      <b-th width="20px">{{language_terms['DATE']}}</b-th>
                      <b-th>{{language_terms['PRODUCT_CODE']}}</b-th>
                      <b-th>{{language_terms['PRODUCT_NAME']}}</b-th>
                      <b-th width="20px">{{language_terms['QTY']}}</b-th>
                      <b-th>{{language_terms['REMARKS']}}</b-th>
                      <!-- <b-th>{{language_terms['TYPE']}}</b-th> -->
                      <b-th>{{language_terms['CREATED_BY']}}</b-th>
                    </b-thead>
                    <b-tbody>
                      <tr v-for="(item, index) in items" :key="index" @click="onClickTableRowItem(item)">
                        <td>{{item.code}}</td>
                        <td>{{item.date}}</td>
                        <td>{{item.product_code}}</td>
                        <td>{{item.product_name}}</td>
                        <td>{{item.qty}}</td>
                        <td>{{item.remarks}}</td>
                        <!-- <td>{{item.type}}</td> -->
                        <td>{{item.creator_user_name}}</td>
                      </tr>
                    </b-tbody>
                  </b-table-simple>
                </b-col>
                </b-row>
              </card>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import moment from 'moment'
import { Select, Option } from 'element-ui';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapState } from "vuex";
import axios from "axios";
import { apiRoutes } from "../../../apiRoutes";
import { authHeader } from "../../../global";
import PaginatedTables from '@/views/Tables/PaginatedTables';
import Vue from 'vue'


export default {
  components: {
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    PaginatedTables,
  },
  computed: {
    ...mapState({
      receipt_filter: state => state.receipts.filter,
      language_terms: state => state.languages.language_terms,
      selected_lang: state => state.languages.selected_langauge,
      receipts: state => state.receipts.sales_receipts

    }),
  },
  data() {
    return {
      loadingCounter:0,
      fullPage: true,
      filter: {
        is_assembled:1,
        keyword: "",
        from_date:moment().format("YYYY-MM-DD"),
        to_date:moment().format("YYYY-MM-DD"),
      },
      items: [],
      assembly_options:[
        {
            label: "Assembly",
            value: 1
        },
        {
            label: "Disassembly",
            value: 0
        },
      ]
    }
  },
  async mounted(){
    this.onClickSearch()
  },
  methods: {
    async onClickTableRowItem(item)
    {
      if(item)
      {
        this.loadingCounter++
        let payload = {code:item.code}
        await axios
        .post(apiRoutes["BOMASSEMBLIES_RETRIEVE"], payload, authHeader())
        .then((response) => 
        {
          if (response.data.code == 1) {
            this.$router.push("/inventory/bom-assembly/" +  encodeURIComponent(item.code));          
          } 
          else 
          {
            alert('Failed');
          }

        })
        .catch((error) => {
          if (error.response) {
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          }
        });
        
        this.loadingCounter--
      }
    },

    async onClickSearch() {
      this.loadingCounter++

      let payload = this.filter
      await axios.post(apiRoutes["BOMASSEMBLIES_QUICKSEARCH"], payload, authHeader()).then((response) => {
        if (response.data.code == 1) {
          this.items = response.data.data;
        } else {
          this.items = [];
        }
      })
        .catch((error) => {
          if (error.response) {
            Vue.notify({ group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300, });
          }
        });
      this.loadingCounter--
    },
    async onClickAdd() {
      let url = '/inventory/bom-assembly/_new'
      this.$router.push(url)
    }
  }
}
</script>
